const isExcludeTopN = (
  groupByLimitMode: 'top n' | 'show all' | ExcludeTopN | undefined,
): groupByLimitMode is ExcludeTopN =>
  typeof groupByLimitMode === 'object' &&
  groupByLimitMode.type === 'exclude top n';

const limitModeTypeCheckers = {
  isExcludeTopN,
};

export default limitModeTypeCheckers;
